import { AxiosInstance } from 'axios';

import { axios } from '../../../api/axios-instance';
import { teamEndpoints } from '../../../constants';
import { ITeam, ITeamEmployee } from '../team';
import { TeamCreate, TeamUpdate } from '../team.schema';

class TeamApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getTeamById = async (id: number): Promise<ITeam> => {
    return this.#requestInstance.get(teamEndpoints.getTeamById(id));
  };

  create = (team: TeamCreate): Promise<ITeam> => {
    return this.#requestInstance.post(teamEndpoints.team, team);
  };

  update = async (input: TeamUpdate & { id: number }) => {
    return this.#requestInstance.patch(teamEndpoints.getTeamById(input.id), input);
  };
  remove = async (id: number) => {
    return this.#requestInstance.delete(teamEndpoints.getTeamById(id));
  };

  getTeams = async (): Promise<(ITeam & { employeesCount: number })[]> => {
    return this.#requestInstance.get(teamEndpoints.team);
  };

  getTeamEmployees = async (): Promise<ITeamEmployee[]> => {
    return this.#requestInstance.get(teamEndpoints.teamEmployee);
  };
}

export const teamApi = new TeamApi(axios);
